import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addBankAccount, getCurrentAccount } from '../../utils/actions';
import { useNavigate } from 'react-router-dom';
import { BuildingOfficeIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import 'react-phone-input-2/lib/style.css';
import NavHeader from '../../layouts/NavHeader';
import Footer from '../../layouts/Footer';
import FileInput from '../../layouts/FileInput';

const BankAccountDetails = ({ entity }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const account = JSON.parse(localStorage.getItem('account'));
    const profile = account.profiles.find((profile) => profile.account_id === account.id);

    const profileName = profile.name;
    const profileType = profile.type;
    const profileStatus = profile.status;

    const entityId = profile.entity_id;
    const profileId = profile.id;

    const [bankAccountData, setbankAccountData] = useState({
        entity_id: entityId,
        account_id: account.id,
        profile_id: profileId,
        bank_account_name: '',
        bank_account_number: '',
        bank_address: '',
        bank_name: '',
        iban_code: '',
        swift_code: '',
        branch_code: '',
        status: "active",
        financial_audit_doc: '',
        current_management_accounts_doc: ''
    });

    const [selectedFiles, setSelectedFiles] = useState({
        financial_audit_doc: null,
        current_management_accounts_doc: null
    });


    const validateInputs = (data) => {
        const errors = {};

        if (!data.bank_account_name)
        {
            errors.bank_account_name = 'Please enter bank account name';
        }

        if (!data.bank_name)
        {
            errors.bank_name = 'Please enter bank name';
        }

        if (!data.bank_account_number)
        {
            errors.bank_account_number = 'Please enter account number';
        }

        if (!data.bank_address)
        {
            errors.bank_address = 'Please enter bank physical address';
        }

        if (!data.swift_code)
        {
            errors.swift_code = 'Please enter bank swift code';
        }

        if (!data.branch_code)
        {
            errors.branch_code = 'Please enter bank Branch code';
        }

        return errors;
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setbankAccountData((prevData) => ({ ...prevData, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        // Validate inputs;
        const inputErrors = validateInputs(bankAccountData);
        if (Object.keys(inputErrors).length > 0)
        {
            setErrors(inputErrors);
            return;
        }

        try
        {
            setLoading(true);
            await dispatch(addBankAccount(bankAccountData));
            await dispatch(getCurrentAccount());
            setLoading(false);
            navigate('/registration_declaration');
        } catch (error)
        {
            if (error.response && error.response.data && error.response.data.errors)
            {
                setErrors(error.response.data.errors);
            } else
            {
                console.error(error);
            }
        } finally
        {
            setLoading(false);
        }
    };

    const MAX_FILE_SIZE_MB = 20;

    const handleFileChange = (e, fieldName) => {
        const selectedFile = e.target.files[0];

        if (selectedFile)
        {
            const fileSizeInMB = selectedFile.size / (1024 * 1024);
            if (fileSizeInMB > MAX_FILE_SIZE_MB)
            {
                setSelectedFiles((prevFiles) => ({ ...prevFiles, [fieldName]: null }));
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [fieldName]: `File size exceeds the ${MAX_FILE_SIZE_MB}MB limit.`,
                }));
                return;
            }

            const allowedFileTypes = [
                'application/pdf',
            ];

            if (allowedFileTypes.includes(selectedFile.type))
            {
                setbankAccountData((prevData) => ({ ...prevData, [fieldName]: selectedFile }));
                // setSelectedFiles((prevFiles) => ({ ...prevFiles, [fieldName]: selectedFile }));
            } else
            {
                setbankAccountData((prevData) => ({ ...prevData, [fieldName]: null }));
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [fieldName]: 'Please select a valid PDF Document (.PDF).',
                }));
            }
        }
    };

    return (
        <>
            <NavHeader />
            <section className="flex h-screen ">
                <div className="w-full lg:px-9">
                    <div className="relative overflow-hidden bg-white dark:bg-gray-800 sm:rounded-lg">
                        <div className="grid w-full place-items-center bg-white p-6 sm:p-16 lg:p-8">
                            <ol className="items-center w-full space-y-4 sm:flex sm:space-x-8 sm:space-y-0">
                                <li className="flex items-center text-gray-600 dark:text-gray-500 space-x-2.5">
                                    <span className="flex items-center justify-center w-8 h-8 border border-gray-600 rounded-full shrink-0 dark:border-gray-500">
                                        2
                                    </span>
                                    <span>
                                        <h3 className="font-medium leading-tight">Verify your registration</h3>
                                        <p className="text-sm">Use OTP for verification</p>
                                    </span>
                                </li>
                                <li className="flex items-center text-gray-500 dark:text-gray-400 space-x-2.5">
                                    <span className="flex items-center justify-center w-8 h-8 border border-gray-500 rounded-full shrink-0 dark:border-gray-400">
                                        3
                                    </span>
                                    <span>
                                        <h3 className="font-medium leading-tight">Membership Type</h3>
                                        <p className="text-sm">Set membership type</p>
                                    </span>
                                </li>
                                <li className="flex items-center text-gray-600 dark:text-gray-500 space-x-2.5">
                                    <span className="flex items-center justify-center w-8 h-8 border border-gray-600 rounded-full shrink-0 dark:border-gray-500">
                                        4
                                    </span>
                                    <span>
                                        <h3 className="font-medium leading-tight">Organization Information</h3>
                                        <p className="text-sm">Provide organization details</p>
                                    </span>
                                </li>
                                <li className="flex items-center text-gray-600 dark:text-gray-500 space-x-2.5">
                                    <span className="flex items-center justify-center w-8 h-8 border border-gray-600 rounded-full shrink-0 dark:border-gray-500">
                                        5
                                    </span>
                                    <span>
                                        <h3 className="font-medium leading-tight">{profileType == 'cooperative' ? 'Executive Members' : 'Directors & Management'}</h3>
                                        <p className="text-sm">Provide KYC information</p>
                                    </span>
                                </li>
                                <li className="flex items-center text-green-600 dark:text-green-500 space-x-2.5">
                                    <span className="flex items-center justify-center w-8 h-8 border border-green-600 rounded-full shrink-0 dark:border-green-500">
                                        6
                                    </span>
                                    <span>
                                        <h3 className="font-medium leading-tight">Add Financial Details</h3>
                                        <p className="text-sm">Provide Financial Details</p>
                                    </span>
                                </li>
                                <li className="flex items-center text-gray-600 dark:text-gray-500 space-x-2.5">
                                    <span className="flex items-center justify-center w-8 h-8 border border-gray-600 rounded-full shrink-0 dark:border-gray-500">
                                        7
                                    </span>
                                    <span>
                                        <h3 className="font-medium leading-tight">Submit Registration</h3>
                                        <p className="text-sm">Submit registration for verification</p>
                                    </span>
                                </li>
                            </ol>

                            <form onSubmit={handleSubmit}>
                                <br />

                                <div className="flex flex-col items-stretch justify-start border-t border-gray-100">
                                    <h3 className="text-2xl font-bold leading-7 text-green-800 sm:truncate sm:text-2xl sm:tracking-tight">
                                        Registrant Name: {profileName}
                                    </h3>
                                    <br />
                                    <div className="flex flex-row space-x-6">
                                        <div className="flex items-center text-sm text-green-800">
                                            <BuildingOfficeIcon className="mr-1.5 h-5 w-5 flex-shrink-0 text-green-800" aria-hidden="true" />
                                            <span className="font-bold uppercase">{profileType}</span>
                                        </div>
                                        <div className="flex items-center text-sm text-red-800">
                                            <InformationCircleIcon className="mr-1.5 h-5 w-5 flex-shrink-0 text-red-800" aria-hidden="true" />
                                            <span className="font-bold uppercase">{profileStatus}</span>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <p class="text-xl font-semibold text-green-600/100 dark:text-green-500/100">Details of {profileName}'s Bank Account</p>
                                <p class="tracking-tighter text-gray-500 md:text-lg dark:text-gray-400">Provide details of the primary bank account {profileName} will use to transaction with ZAMACE.</p>
                                <hr className='my-2' />
                                <p class="tracking-tighter text-gray-500 md:text-md dark:text-gray-400"><span className='text-red-500 mr-2'>*</span>Financial Audit Document is an Optional Field and should at least Track back to 2 years.</p>
                                <p class="tracking-tighter text-gray-500 md:text-md dark:text-gray-400"><span className='text-red-500 mr-2'>*</span>Current Management Account Document Upload is an optional Field and should track back to at least 3 months.</p>
                                <p class="tracking-tighter text-gray-500 md:text-md dark:text-gray-400"><span className='text-red-500 mr-2'>*</span>If you have not uploaded these documents, Zamace will Contact your Organization (if they are required) during Account Verification.</p>
                                <div className="grid gap-6 mb-8 lg:grid-cols-4 p-6 sm:p-16 lg:p-8">

                                    <div>
                                        <label htmlFor="bank_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Select Bank
                                        </label>
                                        <select
                                            name="bank_name"
                                            // value={entityData.type}
                                            value={bankAccountData.bank_name}
                                            onChange={handleInputChange}
                                            // onChange={handleInputChange}
                                            required
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                        >
                                            <option value="">Choose a Bank</option>
                                            <option value="access_bank_zambia">Access Bank Zambia</option>
                                            <option value="atlas_mara_bank">Atlas Mara Bank</option>
                                            <option value="bank_of_china_zambia">Bank of China (Zambia)</option>
                                            <option value="absa_bank_zambia">Absa Bank Zambia</option>
                                            <option value="citibank_zambia">Citibank Zambia</option>
                                            <option value="ecobank_zambia">Ecobank Zambia</option>
                                            <option value="first_alliance_bank_zambia">First Alliance Bank Zambia</option>
                                            <option value="first_capital_bank_zambia">First Capital Bank Zambia</option>
                                            <option value="first_national_bank_zambia">First National Bank Zambia</option>
                                            <option value="indo_zambia_bank">Indo-Zambia Bank</option>
                                            <option value="investrust_bank">Investrust Bank</option>
                                            <option value="stanbic_bank_zambia">Stanbic Bank Zambia</option>
                                            <option value="standard_chartered_bank">Standard Chartered Bank</option>
                                            <option value="united_bank_for_africa_zambia">United Bank for Africa Zambia</option>
                                            <option value="zambia_industrial_commercial_bank">Zambia Industrial Commercial Bank</option>
                                            <option value="zambia_national_commercial_bank">Zambia National Commercial Bank</option>
                                        </select>
                                        {/* {errors.type && (
        <p className="text-red-500 text-xs mt-1">{errors.type[0]}</p>
    )} */}
                                    </div>

                                    <div>
                                        <label htmlFor="bank_account_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Bank Account Name
                                        </label>
                                        <input
                                            iban_code="text"
                                            name="bank_account_name"
                                            value={bankAccountData.bank_account_name}
                                            onChange={handleInputChange}
                                            required
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                        />
                                        {errors.bank_account_name && <p className="text-red-500 text-xs mt-1">{errors.bank_account_name}</p>}
                                    </div>

                                    {/* <div>
                                        <label htmlFor="bank_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Full Bank Name
                                        </label>
                                        <input
                                            iban_code="text"
                                            name="bank_name"
                                            value={bankAccountData.bank_name}
                                            onChange={handleInputChange}
                                            required
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                        />
                                        {errors.bank_name && <p className="text-red-500 text-xs mt-1">{errors.bank_name}</p>}
                                    </div> */}

                                    <div>
                                        <label htmlFor="bank_account_number" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Bank Account Number
                                        </label>
                                        <input
                                            iban_code="number"
                                            name="bank_account_number"
                                            value={bankAccountData.bank_account_number}
                                            onChange={handleInputChange}
                                            required
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                        />
                                        {errors.bank_account_number && <p className="text-red-500 text-xs mt-1">{errors.bank_account_number}</p>}
                                    </div>

                                    <div>
                                        <label htmlFor="bank_account_number" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Bank Branch Name & Address
                                        </label>
                                        <input
                                            iban_code="text"
                                            name="bank_address"
                                            value={bankAccountData.bank_address}
                                            onChange={handleInputChange}
                                            required
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                        />
                                        {errors.bank_address && <p className="text-red-500 text-xs mt-1">{errors.bank_address}</p>}
                                    </div>

                                    <div>
                                        <label htmlFor="branch_code" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Bank Branch Code
                                        </label>
                                        <input
                                            iban_code="text"
                                            name="branch_code"
                                            value={bankAccountData.branch_code}
                                            onChange={handleInputChange}
                                            required
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                        />
                                        {errors.branch_code && <p className="text-red-500 text-xs mt-1">{errors.branch_code}</p>}
                                    </div>
                                    <div>
                                        <label htmlFor="swift_code" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Bank SWIFT Code
                                        </label>
                                        <input
                                            iban_code="text"
                                            name="swift_code"
                                            value={bankAccountData.swift_code}
                                            onChange={handleInputChange}
                                            required
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                        />
                                        {errors.swift_code && <p className="text-red-500 text-xs mt-1">{errors.swift_code}</p>}
                                    </div>
                                    <div>
                                        <FileInput
                                            label="Upload Financial Audit (Optional)"
                                            name="financial_audit_doc"
                                            onChange={(e) => handleFileChange(e, 'financial_audit_doc')}
                                        />
                                        {errors.financial_audit_doc && <p className="text-red-500 text-xs mt-1">{errors.financial_audit_doc}</p>}
                                    </div>
                                    <div>
                                        <FileInput
                                            label="Upload Current Management Accounts (Optional)"
                                            name="current_management_accounts_doc"
                                            onChange={(e) => handleFileChange(e, 'current_management_accounts_doc')}
                                        />
                                        {errors.current_management_accounts_doc && <p className="text-red-500 text-xs mt-1">{errors.current_management_accounts_doc}</p>}
                                    </div>
                                    {/* <div>
                                        <label htmlFor="iban_code" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Bank IBAN (if applicable)
                                        </label>
                                        <input
                                            iban_code="text"
                                            name="iban_code"
                                            value={bankAccountData.iban_code}
                                            onChange={handleInputChange}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                        />
                                        {errors.iban_code && <p className="text-red-500 text-xs mt-1">{errors.iban_code}</p>}
                                    </div> */}

                                </div>

                                {Object.entries(errors).map(([field, messages]) => (
                                    Array.isArray(messages) && messages.length > 0 && (
                                        <div
                                            key={field}
                                            className="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
                                            role="alert"
                                        >
                                            {messages.map((message, idx) => (
                                                <p className="font-medium" key={idx}>
                                                    {message}
                                                </p>
                                            ))}
                                        </div>
                                    )
                                ))}

                                {loading && (
                                    <div className="text-center">
                                        <div role="status">
                                            <svg
                                                aria-hidden="true"
                                                className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-600"
                                                viewBox="0 0 100 101"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="currentColor"
                                                />
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill"
                                                />
                                            </svg>
                                            <span className="sr-only">Please wait...</span>
                                        </div>
                                    </div>
                                )}
                                <button
                                    type="submit"
                                    className="text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                                >
                                    Add {profileName}'s Bank Account
                                </button>


                            </form>

                        </div>

                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default BankAccountDetails;
